// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__0D1uq","spinnerBorder":"Spinner_spinnerBorder__0Kw2N"};